import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
  } from "react";
  import axios from "axios";
  import { fetchAuthSession } from "@aws-amplify/auth";
  import { useAuth } from "./AuthContext";
  
 const ProfileContext = createContext(null);


export const profileLabels = {
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  phone: "Phone",
  jobTitle: "Job Title",
  companyName: "Company Name",
  website: "Website",
  industry: "Industry",
  businessType: "Business Type",
  targetAudience: "Target Audience",
  employeeSize: "Employee Size",
  revenue: "Revenue",
};

export function ProfileProvider({ children }) {
    const { user } = useAuth();
const apiBase = process.env.REACT_APP_API_URL || "http://localhost:3001";
  const getAuthHeaders = async () => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      return token ? { Authorization: `Bearer ${token}` } : {};
    } catch {
      return {};
    }
  };
  const [userRole, setUserRole] = useState("");
  const [loading, setLoading] = useState(true);
  const [profileData, setProfileData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    jobTitle: "",
    companyName: "",
    website: "",
    industry: "",
    businessType: "",
    targetAudience: "",
    employeeSize: "",
    revenue: "",
  });

    useEffect(() => {
        const fetchUserAndPopulate = async () => {
        setLoading(true);
        try {
            const userId = user?.userId || (typeof window !== "undefined" && localStorage.getItem("mb_userId"));
            if (!userId) return;

            const headers = await getAuthHeaders();
            const resp = await axios.get(`${apiBase}/users/${userId}`, { headers });
            const data = resp?.data?.user;
            setUserRole(data.role);
            if (!data) return;

            setProfileData({
            firstName: data.firstName || "",
            lastName: data.lastName || "",
            email: data.email || "",
            phone: data.phone || "",
            jobTitle: data.jobTitle || "",
            companyName: data.companyName || "",
            website: data.website || "",
            industry: data.industry || "",
            businessType: data.businessType || "",
            targetAudience: data.targetAudience || "",
            employeeSize: data.employeeSize || "",
            revenue: data.revenue || "",
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error("Failed to fetch account info", err);
        }
        finally {
            setLoading(false);
        }
        };

        fetchUserAndPopulate();
        }, [user]);
        return (
      <ProfileContext.Provider value={{ profileData, setProfileData, profileLabels, user, userRole, getAuthHeaders, apiBase, loading }}>
        {children}
      </ProfileContext.Provider>
    );
};

export function useProfileSetup() {
    const ctx = useContext(ProfileContext);
    if (!ctx) {
      throw new Error("useProfileSetup must be used within a ProfileProvider");
    }
    return ctx;
}
